import React from "react";
import { render } from "react-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { I18n } from "../utils/I18n";
import AlertDialog from "../utils/AlertDialog";

export default class SettingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CompanyName: "",
      CompanyDescription: "",
      ManagerEmail: "",
      InterfaceLanguage: "zh-tw",
    };
    this.CompanyNameChange = this.CompanyNameChange.bind(this);
    this.CompanyDescriptionChange = this.CompanyDescriptionChange.bind(this);
    this.ManagerEmailChange = this.ManagerEmailChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    console.log("Setting page init.");
  }

  componentDidMount() {
    fetch("/api/company/info", { credentials: "include" })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ CompanyName: result.data.name });
          if (result.data.description != null) {
            this.setState({ CompanyDescription: result.data.description });
          }
          if (result.data.adminEmail != null) {
            this.setState({ ManagerEmail: result.data.adminEmail });
          }
        },
        (error) => {
          console.log("error in getCompanyInfo:", error);
        }
      );

    fetch("/api/account/info", { credentials: "include" })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result.data);
          this.setState({ InterfaceLanguage: result.data.locale });
        },
        (error) => {
          console.log("error in getCompanyAccount:", error);
        }
      );

    // componentDidMount 結束
  }

  // 修改公司名稱
  CompanyNameChange = (event) => {
    this.setState({ CompanyName: event.target.value });
  };

  //修改公司描述
  CompanyDescriptionChange = (event) => {
    this.setState({ CompanyDescription: event.target.value });
  };
  // 修改管理者email
  ManagerEmailChange = (event) => {
    this.setState({ ManagerEmail: event.target.value });
  };
  // 修改介面語言
  handleLanguageChange(event) {
    this.setState({ InterfaceLanguage: event.target.value });
    // alert(event.target.value);
  }

  render() {
    return (
      <div
        className="d-flex align-items-end flex-column"
        style={{
          height: "94vh",
          paddingTop: "20px",
          paddingLeft: "2%",
          paddingRight: "2%",
          paddingBottom: "0px",
        }}
      >
        <div className="d-flex flex-row align-items-center w-100">
          <h4>
            <b>
              <u>{I18n.t("SettingPage.Setting")}</u>
            </b>
          </h4>
        </div>

        <div className="row " style={{ width: "100%", height: "100%" }}>
          <div style={{ width: "40%" }}>
            <Form>
              <Form.Group as={Row} controlId="SettingName">
                <Form.Label column sm="3">
                  {I18n.t("SettingPage.CompanyLabel")}
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="Text"
                    value={this.state.CompanyName}
                    onChange={this.CompanyNameChange}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="SettingDescibe">
                <Form.Label column sm="3">
                  {I18n.t("SettingPage.CompanyDescribe")}
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="Text"
                    value={this.state.CompanyDescription}
                    onChange={this.CompanyDescriptionChange}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="SettingDescibe">
                <Form.Label column sm="3">
                  {I18n.t("SettingPage.ManagerEmail")}
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="Text"
                    value={this.state.ManagerEmail}
                    onChange={this.ManagerEmailChange}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="SettingDescibe">
                { /*
                <Form.Label column sm="3">
                  {I18n.t("SettingPage.PlatLang")}
                </Form.Label>
                <Col sm="4">
                  <Form.Control
                    as="select"
                    onChange={this.handleLanguageChange}
                  >
                    <option value="zh-tw">繁體中文</option>
                    <option value="jp">日文</option>
                    <option value="en-us">English</option>
                  </Form.Control>
                </Col>
                */ }

                <Col sm="3">
                  <Button
                    type="button"
                    onClick={() => {
                      fetch("/api/company/info", {
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                        },
                        method: "PUT",
                        body: JSON.stringify({
                          name: this.state.CompanyName,
                          description: this.state.CompanyDescription,
                          adminEmail: this.state.ManagerEmail,
                        }),
                      })
                        .then(function (res) {
                          console.log(res);
                        })
                        .catch(function (res) {
                          console.log(res);
                        });

                      fetch("/api/account/edit", {
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                          locale: this.state.InterfaceLanguage,
                        }),
                      })
                        .then(function (res) {
                          console.log(res);
                        })
                        .catch(function (res) {
                          console.log(res);
                        });

                      AlertDialog.show(
                        I18n.t("SettingPage.SaveSetting"),
                        I18n.t("SettingPage.Success")
                      );
                    }}
                    variant="outline-light"
                    style={{
                      width: "205px",
                      borderRadius: "10px",
                      boxShadow: "2px 2px 10px #333",
                      backgroundColor: "#00a0e9",
                    }}
                  >
                    {I18n.t("SettingPage.SaveSetting")}
                  </Button>
                </Col>
              </Form.Group>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
